import React from 'react'

import { useBrandAccountId } from '../useBrandAccountId'

export const useArchivedDocumentReportsInfiniteQueryKey = () => {
  const brandAccountId = useBrandAccountId()

  return React.useMemo(
    () =>
      [
        'DocumentReportArchiveListPage_DocumentReports',
        { brandAccountId },
      ] as const,
    [brandAccountId],
  )
}
